export const isNotDevelopmentMode = process.env.NODE_ENV !== 'development';
export const isReCaptchaEnabled = JSON.parse(process.env.REACT_APP_RECAPTCHA_ENABLED ?? '');
